import FreePracticeTopic from '@cont/Practice/Free/FreePracticeTopic';
import fetchFreePracticeTopologies, {
  fetchFreePracticeQuestions
} from '@actions/freePracticeSession';
import redirectToPractice from '@cont/Practice/Free/helpers/redirectToPractice';
import { useSetSelectedNav } from '@stores/sidenav';
import setupInitialProps from '@utils/setupInitialProps';
import pushRoute from '@utils/pushRoute';
import Layout from '@layout/index';
import fetchIsGoalGTP from '@api/fetchers/constants';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import { getMe } from '@selectors/auth';
import { hasActiveSubscriptionToGoal } from '@models/Me';
import { redirectToRoute } from '@utils/route';

function FreePracticeTopicsPage() {
  useSetSelectedNav('practice');
  return <FreePracticeTopic />;
}

FreePracticeTopicsPage.pageInfo = {
  isMWebSupported: true,
  layoutOptions: {
    showPlusNav: true,
    hideIntercom: true
  }
};

FreePracticeTopicsPage.getInitialProps = setupInitialProps(
  async ({ store, query, isServer, res, isMobile }) => {
    const { topicUID, goalUID, goalSlug } = query;
    const {
      auth: { isLoggedIn }
    } = store.getState();
    const state = store.getState();
    const meData = getMe(state);
    const isPlusUser = hasActiveSubscriptionToGoal(meData, goalUID);
    const isGTP = await fetchIsGoalGTP(goalUID, store);

    if (!isPlusUser && isGTP)
      return redirectToRoute(isServer, res, `/goal/${goalSlug}/${goalUID}`);

    if (isGTP && !isLoggedIn) {
      if (isServer) {
        res.writeHead(302, {
          Location: `/goal/${goalSlug}/${goalUID}/practice/topics`
        });
        return res.end();
      }

      return pushRoute(`/goal/${goalSlug}/${goalUID}/practice/topics`);
    }

    const promises = [
      store.dispatch(
        fetchFreePracticeTopologies({
          goalUID: topicUID,
          subTopic: true,
          isGTP
        })
      ),
      store.dispatch(fetchFreePracticeQuestions({ topicUID, goalUID, isGTP }))
    ];

    const [result1] = await Promise.all(promises);
    redirectToPractice({
      store,
      res,
      goalUID,
      isServer,
      isMobile,
      redirect: isGTP ? false : result1.result?.concepts_count === 0
    });
    return {};
  },
  FreePracticeTopicsPage.pageInfo
);

export default FreePracticeTopicsPage;
FreePracticeTopicsPage.Layout = Layout;
FreePracticeTopicsPage.Wrapper = PageReduxProvider;
